module.exports = __webpack_public_path__ + "img/step-3.d2abf5dc.png";